import React from 'react'
import {DashboardComponent} from "../components";

export const DashboardPage: React.FC = () => <DashboardComponent/>;
